import { Divider, Stack, Typography } from "@mui/material";
import useLocales from "src/hooks/useLocales";

// ----------------------------------------------------------------------

export const LegendChart = () => {
	const { translate } = useLocales();
	return (
		<Stack sx={{ mt: 4 }}>
			<Divider sx={{ borderStyle: "dashed", mb: 3.6 }} />
			<Stack direction='row' alignItems={"center"} justifyContent={"center"}>
				<Stack direction='row' alignItems={"center"} justifyContent={"center"}>
					<Stack sx={{ height: 12, width: 12, backgroundColor: "#36B37E", borderRadius: 5 }} />
					<Typography variant='subtitle2' sx={{ color: "text.primary", ml: 1 }}>
						{translate("overview.success")}
					</Typography>
				</Stack>
				<Stack direction='row' alignItems={"center"} justifyContent={"center"} ml={2}>
					<Stack sx={{ height: 12, width: 12, backgroundColor: "#FF5630", borderRadius: 5 }} />
					<Typography variant='subtitle2' sx={{ color: "text.primary", ml: 1 }}>
						{translate("overview.error")}
					</Typography>
				</Stack>
			</Stack>
		</Stack>
	);
};

export default LegendChart;
